// components.js houses the vue comonents throughout the site

import Vue from 'vue';
import BpTabs from './components/BpTabs';
import EventRegistration from './components/eventRegistration';
import PardotGate from './components/PardotGate.vue';
import ProfileUpdate from './components/ProfileUpdate';
import VueSanitize from "vue-sanitize";

new Vue({
    el: '#app',

    data: {
        isOpen: false,
        image: '',
    },

    components: {
        BpTabs,
        EventRegistration,
        ProfileUpdate,
        PardotGate,
    },
});
Vue.use(VueSanitize);
